import * as React from 'react';

import {translateConnectionObjectToArray} from 'nutshell-core/translate-connection-obj-to-array';

import {TagsEditor} from 'shells/tags-editor/tags-editor';

import {useGetAccountInfo} from '../../entity-details/peep-details/account-details/use-get-account-info';
import {useUpdateAccountInfo} from '../../entity-details/peep-details/account-details/use-update-account-info';

import {combineFetchedOptionsWithCurrentOptions} from '../select/helpers';
import {useGetTags} from '../select/hooks/use-get-tags';
import {useGetSessionUser} from '../use-get-session-user';

import {getTagsFromTagMapEdges, castGraphqlTagsToTagType} from './helpers';

type Props = {
    accountId: string;
};

export function AccountTags(props: Props) {
    const {user} = useGetSessionUser();
    const {accountInfo, isLoading} = useGetAccountInfo(props.accountId);
    const accountTags =
        accountInfo && accountInfo.tagMaps ? getTagsFromTagMapEdges(accountInfo.tagMaps.edges) : [];

    const {fetchMore} = useGetTags({
        tagType: 'ACCOUNT',
    });

    const updateAccountInfo = useUpdateAccountInfo();
    const handleUpdateAccount = (updatedTags: any[]) => {
        const mappedTags = updatedTags.map((tag) => ({tagType: 'ACCOUNT', name: tag.name}));
        // @ts-expect-error
        updateAccountInfo({accountId: props.accountId, tags: mappedTags});
    };

    if (isLoading) return null;

    return (
        <TagsEditor
            key={props.accountId}
            fetchTags={(searchTerm, currentTags) =>
                fetchMore(searchTerm, 'ACCOUNT')
                    .then(({data}) =>
                        data
                            ? castGraphqlTagsToTagType(translateConnectionObjectToArray(data.tags))
                            : []
                    )
                    .then((fetchedTags) =>
                        combineFetchedOptionsWithCurrentOptions(fetchedTags, currentTags)
                    )
            }
            appliedTags={accountTags}
            onUpdateTags={handleUpdateAccount}
            user={{id: user ? user.id : '', name: user ? user.name : ''}}
        />
    );
}
